import {ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {ModalService} from '../../../../components/modal';
import {OverlayService} from '../../../../components/overlay';
import {DisplayDecimal, formatPrice, SymbolDecimalsService} from '../../../../components/symbol-decimals';
import {Security} from '../../../../models/security';
import {CellSizeObserverService} from '../../../../pages/dashboard/layout/cell/cell-size-observer.service';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';

@Component({
    selector: 'widget-order-min-notional-alert',
    templateUrl: 'widget-order-min-notional-alert.component.html',
    styleUrls: ['./widget-order-min-notional-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderMinNotionalAlertComponent extends WidgetInnerAlertComponent implements OnInit {

    @Input()
    public security: Security;

    @Input()
    public isIcebergAlert: boolean = false;

    public minNotionalDisplayDecimal: DisplayDecimal<string>;

    constructor(
        elementRef: ElementRef,
        modalService: ModalService,
        overlayService: OverlayService,
        cellSizeObserverService: CellSizeObserverService,
        renderer: Renderer2,
        private symbolDecimalsService: SymbolDecimalsService
    ) {
        super(
            elementRef,
            modalService,
            overlayService,
            cellSizeObserverService,
            renderer
        );
    }

    public override ngOnInit(): void {
        const symbolDecimalsInputParams = this.symbolDecimalsService.getSecurityInputParams(this.security);
        const symbolFormats = this.symbolDecimalsService.getSecurityFormats(this.security);

        this.minNotionalDisplayDecimal = formatPrice(
            symbolDecimalsInputParams.min.notional,
            symbolFormats
        );

        super.ngOnInit();
    }

}
